import { GlobalService } from './../global/global.service';
import { GeolocationWrapperService } from './../geolocation/geolocation.service';
import { CommonService } from './../common/common.service';
import { ApiService } from './../api/api.service';
import { Injectable } from '@angular/core';
import { ApiReturn } from 'src/app/services/api/apireturn';
import { MonitorSession, ChatMessage } from './monitoringsession';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/internal/Observable';
import { Platform } from '@ionic/angular';

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

// add global variables here
import * as Constants from '../constants/constants';
//import { elementStart } from '@angular/core/src/render3';

@Injectable({
  providedIn: 'root'
})
export class MonitoringService {

  private consoleLog:boolean = false;
  private apiReturn:ApiReturn = new ApiReturn();
  private apiResponse:any;

  private monitoringObserver: any;
  public monitoring: any;

  //private _isMonitoring:boolean;
  private _isApiCallPending:boolean = false;
  private _isApiCallError:boolean = false;
  private _isApiCallOk:boolean = false;
  private _communicationStatus:string = "";
  //private MobileMonitorUpdatesCount:number = 0;
  //private MobileMonitorId:string = "";
  //private MobileMonitorTypeCode:string = "";
  //private MobileMonitorSessionCode:string = "";
  private monitorSession:MonitorSession = new MonitorSession();

  //private MobileMonitorChatInTransitText:string = "";

  private monitorTimerObserver: any;
  public monitorTimer: any;

  private _isMonitorTimerOn:boolean = false;
  private _timerInstance:number;
  private _countdownTotal:number = 15;
  private _countdownCurrent:number = 15;

  constructor(private apiProvider: ApiService
    , private commonProvider: CommonService
    , private geolocationProvider: GeolocationWrapperService
    , public events: Events
    , public translate: TranslateService
    , public globalProvider: GlobalService
    , public platform: Platform
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_monitoring;
    if (this.consoleLog) console.log('MonitoringProvider.ctor - LifeCycle');
    //this.InitializeProvider();

    this.platform.ready().then(() => {
      this.InitializeProvider();
    });
  }

  InitializeProvider()
  {
    this.SetupObservableTimerCountdown();
    this.SetupObservableMonitoring();
  }

  SetupObservableMonitoring()
  {
    //if (this.consoleLog) 
    console.log("MonitoringProvider.SetupObservableMonitoring");
    this.monitoringObserver = null;
    this.monitoring = Observable.create(observer => {
        console.log("MonitoringProvider.SetupObservableMonitoring - created observable monitoringObserver");
        this.monitoringObserver = observer;
        this.CheckForExistingMonitoring();
    });
  }

  SetupObservableTimerCountdown()
  {
    //if (this.consoleLog) 
    console.log("MonitoringProvider.SetupObservableTimerCountdown");
    this.monitorTimerObserver = null;
    this.monitorTimer = Observable.create(observer => {
        console.log("MonitoringProvider.SetupObservableTimerCountdown - created observable monitorTimerObserver");
        this.monitorTimerObserver = observer;
        this.CheckForExistingMonitoring();
    });
  }

  private CheckForExistingMonitoring()
  {
    if ((this.monitoringObserver === undefined) || (this.monitoringObserver === null))
    {
      if (this.consoleLog) console.log("MonitoringProvider.CheckForExistingMonitoring: none (no monitoringObserver) ");
      return;
    }
    if ((this.monitorTimerObserver === undefined) || (this.monitorTimerObserver === null))
    {
      if (this.consoleLog) console.log("MonitoringProvider.CheckForExistingMonitoring: none (no monitorTimerObserver) ");
      return;
    }
    //if ((this._isMonitoring === true) && (this._isMonitorTimerOn))
    if ((this.monitorSession.ActiveMonitor === true) && (this._isMonitorTimerOn))
    {
      if (this.consoleLog) console.log("MonitoringProvider.CheckForExistingMonitoring: true (already active) ");
      return;
    }

    // check to see if there was a previously active session that was never ended properly
    // (maybe the user's phone died, or the app crashed, or they switched devices, etc.)
    if (this.consoleLog) console.log("MonitoringProvider.CheckForExistingMonitoring: not sure (get server status verify) ");
    this.CallGetStatusForMobileMonitor();
  }
  
  // ----------------------------------------------------
  // -----  MAIN MONITOR SESSION START/STOP/RESUME ------
  // ----------------------------------------------------

  // when the mobile user starts a session
  public StartMonitorSession( mobileMonitorTypeCode:string
                            , EventSiteId:number )   // part of GeoFence and Site Proximity to event
  {
    if (this.consoleLog) console.log("MonitoringProvider.StartMonitorSession:" + mobileMonitorTypeCode + " EventSiteId:" + EventSiteId);
    //this._isMonitoring = true;
    //this.monitorSession = new MonitorSession();
    this.monitorSession.ActiveMonitor = true;
    this.monitorSession.MobileMonitorId = "";
    this.monitorSession.MobileMonitorTypeCode = mobileMonitorTypeCode;
    this.monitorSession.MobileMonitorSessionCode = Constants.MONITOR_SESSION_START;
    this.monitorSession.MobileMonitorUpdatesCount = 0;

    this.monitorSession.EventSiteId = EventSiteId;
    if (EventSiteId === 0)
    {
      this.monitorSession.EventSiteId = this.globalProvider.SiteProximity.GetNearestGeofenceSiteId();
    }

    if (this.monitoringObserver) this.monitoringObserver.next(true); // make sure this comes AFTER we set the values above
    this.CallSendMobileMonitorStatus(true);
    this.StartTimer();
  }

  // when the mobile app revives an in progress session
  // (the monitoring session may have been lost due to a phone restart, or app crash or reload, etc.)
  public ReviveInProgressMonitorSession() 
  {  
    if (this.consoleLog) console.log("MonitoringProvider.ReviveInProgressMonitorSession:" + this.monitorSession.MobileMonitorTypeCode);
    //this._isMonitoring = true;
    this.monitorSession.ActiveMonitor = true;
    this.monitorSession.MobileMonitorSessionCode = Constants.MONITOR_SESSION_INPROGRESS;
    if (this.monitoringObserver) this.monitoringObserver.next(true); // make sure this comes AFTER we set the values above
    this.CallSendMobileMonitorStatus(true);
    this.StartTimer();
  }

  // when the mobile user starts a session
  public EndMonitorSession() 
  {  
    if (this.consoleLog) console.log("MonitoringProvider.EndMonitorSession:" + this.monitorSession.MobileMonitorTypeCode);
    //this._isMonitoring = false;
    this.StopTimer();
    this.monitorSession.ActiveMonitor = false;
    this.monitorSession.MobileMonitorSessionCode = Constants.MONITOR_SESSION_END;
    //this.monitorSession.MobileMonitorUpdatesCount = 0;
    //this.MobileMonitorTypeCode = Constants.END;
    if (this.monitoringObserver) this.monitoringObserver.next(false); // make sure this comes AFTER we set the values above
    this.CallSendMobileMonitorStatus(false);
    this.StopTimer(); // redundant but just in case...

    // NOTE:  should we put in a short 3 second timer to wait for the end to complete before releasing UI to user?
    // NOTE:  should we put in a short 3 second timer to wait for the end to complete before releasing UI to user?
    // NOTE:  should we put in a short 3 second timer to wait for the end to complete before releasing UI to user?
    // - trying to prevent weird issue that occurs occasionally where monitor starts up again...
  }

  // when the SYSTEM USER ends a session
  public ForceEndMonitorSession() 
  {  
    if (this.consoleLog) console.log("MonitoringProvider.ForceEndMonitorSession:" + this.monitorSession.MobileMonitorTypeCode);
    //this._isMonitoring = false;
    this.monitorSession.ActiveMonitor = false;
    this.monitorSession.MobileMonitorSessionCode = Constants.MONITOR_SESSION_END;
    if (this.monitoringObserver) this.monitoringObserver.next(false); // make sure this comes AFTER we set the values above
    //this.monitorSession.MobileMonitorUpdatesCount = 0;
    this.StopTimer();
    this.SystemForceEndMobileMonitorStatus();  // no need to call the real API as System has already taken care of it
  }

  public SendChatStatusMessage(mobileMonitorMobilePendingText:string) 
  {  
    //if (this.consoleLog) 
    console.log("MonitoringProvider.SendChatStatusMessage: " + mobileMonitorMobilePendingText);
    this.monitorSession.MobileMonitorChatInTransitText = mobileMonitorMobilePendingText;
    if (this.monitoringObserver) this.monitoringObserver.next(true); 
    this.CallSendMobileMonitorStatus(true);
    this.StartTimer();
  }

  // ----------------------------------------------------
  // -----  INTERNAL FLAGS AND STATUS INFORMATION  ------
  // ----------------------------------------------------

  // use this to initialize each screen's Monitoring status
  public IsMonitoring():boolean
  {
    return this.monitorSession.ActiveMonitor;
    //return this._isMonitoring;
  }

  public IsPanic():boolean
  {
    if ( (this.monitorSession.ActiveMonitor)
        && (this.monitorSession.MobileMonitorTypeCode === Constants.MONITOR_HELP)
       )
    {
      return true;
    }

    return false;
  }

  public IsMonitorTimerOn():boolean
  {
    return this._isMonitorTimerOn;
  }

  myTranslate(value:string):string
  {
    // WARNING! inline translation will CRASH if the value is empty
    if (!value) { return ""; }
    return this.translate.instant(value);
  }

  public GetMonitorStatus():string
  {
    // ToDo:  add HELP/MONITOR level
    //if (!this._isMonitoring)
    if (!this.monitorSession.ActiveMonitor)
    {
      return "Not Monitoring";
    }

    let monitorName = this.myTranslate(Constants.MONITORING_STATUS_MONITOR_ME); 

    if (this.monitorSession.MobileMonitorTypeCode === Constants.MONITOR_HELP)
    {
      monitorName = this.myTranslate(Constants.MONITORING_STATUS_HELP);
    }

    // show an API call in progress for at least one second
    if (this._isApiCallPending === true) { return "<< " + monitorName + " >>"; }
    if (this._countdownCurrent > 14) { return monitorName; }
    
    // show the API success response
    if ((this._countdownCurrent > 13) && (this._isApiCallOk === true)) { return ">> " + monitorName + " <<"; } 
    if ((this._countdownCurrent > 12) && (this._isApiCallOk === true)) { return "> " + monitorName + " <"; } 
    
    // flash the API error response
    if ((this._countdownCurrent > 13) && (this._isApiCallError === true)) { return "xx " + monitorName + " xx"; } 
    if ((this._countdownCurrent > 12) && (this._isApiCallError === true)) { return monitorName; } 
    if ((this._countdownCurrent > 11) && (this._isApiCallError === true)) { return "xx " + monitorName + " xx"; } 
    
    // if we experienced an error, then indicate the error during countdown
    // ToDo: later we could include how long it has been in an error state
    if (this._isApiCallError === true) { monitorName = "xx " + monitorName + " xx"; }

    // indicate the timer countdown
    if (this._countdownCurrent > 11) { return monitorName; }
    if (this._countdownCurrent > 10) { return ". " + monitorName + " ."; }
    if (this._countdownCurrent > 9) { return ".. " + monitorName + " .."; }
    if (this._countdownCurrent > 8) { return "... " + monitorName + " ..."; }
    if (this._countdownCurrent > 7) { return ".... " + monitorName + " ...."; }
    if (this._countdownCurrent > 6) { return "..... " + monitorName + " ....."; }
    if (this._countdownCurrent > 5) { return ".... " + monitorName + " ...."; }
    if (this._countdownCurrent > 4) { return "... " + monitorName + " ..."; }
    if (this._countdownCurrent > 3) { return ".. " + monitorName + " .."; }
    if (this._countdownCurrent > 2) { return ". " + monitorName + " ."; }
    if (this._countdownCurrent > 1) { return monitorName; }

    return monitorName;
  }

  public GetMobileMonitorTypeCode():string
  {
    return this.monitorSession.MobileMonitorTypeCode; // should be same as this.monitorSession.MobileMonitorTypeCode
  }

  public GetActiveStateMonitorTypeCode():string
  {
    //if (!this._isMonitoring)
    if (!this.monitorSession.ActiveMonitor)
    {
      return Constants.MONITOR_SESSION_END;
    }
    return this.monitorSession.MobileMonitorTypeCode;
  }

  public GetCommunicationStatus():string
  {
    return this._communicationStatus;
  }

  public GetMonitorSession():MonitorSession
  {
    return this.monitorSession;
  }

  // ----------------------------------------------------
  // -----    LISTENER SETUP (these do nothing)    ------
  // ----------------------------------------------------

  // Call this from the app when ionic/cordova is ready
  addListeners()
  {
    this.SetListeners(true);
  }

  SetListeners(isStartSubscribe:boolean)
  {
    if (this.consoleLog) console.log('MonitoringProvider.SetListeners ' + isStartSubscribe);
    //if (this.consoleLog) console.log('app.SetListenersNetwork ' + this.network.type, this.network);

    if (isStartSubscribe)
    {
      // nothing external to subscribe to at the moment
      // instead we determine this by triggering 
    }
    else
    {
      //
    }
  }

  // ----------------------------------------------------
  // ------------ LOCATION WATCH DEPENDENCY -------------
  // ----------------------------------------------------
  public SetGeolocationWatchDependency(isLeavingMonitorScreen:boolean)
  {
    // only allow the ending of the geolocation of 
    if (this.monitorSession.MobileMonitorSessionCode === Constants.MONITOR_SESSION_END)
    {
      if (this.globalProvider.GetPanicModeOnlyFlag('MonitoringService'))
      {
        console.log("MonitoringService.SetGeolocationWatchDependency - leaving Watch enabled for Panic Mode")
        return;
      }
      // NOTE:  leaving WATCH DEPENDENCY ON until user leaves screen 
      if (isLeavingMonitorScreen)
      {
        this.geolocationProvider.setWatchDependency(Constants.WATCH_MONITOR, false, "MonitoringService.SetGeolocationWatchDependency(END)");
      }
    }
    else
    {
      this.geolocationProvider.setWatchDependency(Constants.WATCH_MONITOR, true, "MonitoringService.SetGeolocationWatchDependency(" + this.monitorSession.MobileMonitorSessionCode + ")");
    }
  }


  // ----------------------------------------------------
  // --------------- API FUNCTION CALLS       -----------
  // ----------------------------------------------------

  SetApiResponse(data, context)
  {
    //if (!apiResponse) { return; }
    //if ((!apiResponse) || (!apiResponse.ApiReturn)) 
    if (!data)
    {
      console.error("monitoring.SetApiResponse (" + context + ") - missing response", data); 
      return; 
    }
    this.apiResponse = data;

    if (!data.ApiReturn)
    {
      console.error("monitoring.SetApiResponse (" + context + ") - missing ApiResponse", data); 
      return; 
    }
    this.apiReturn.SetApiReturn(data);  // = data.ApiReturn;

    if (this.consoleLog) console.log("monitoring.SetApiResponse (" + context + ") - publish", data);
    this.events.publish('SendMobileMonitorStatus:isResponse', { isResponse: true });
  }

  GetApiReturn():ApiReturn
  {
    return this.apiReturn;
  }

  GetApiResponse():any
  {
    return this.apiResponse;
  }

  public CompareMobileStatusWithServer(isServerActiveSession:boolean)
  {
    console.log("Monitoring.CompareMobileStatusWithServer");

    if (!isServerActiveSession)
    {
      console.log("Monitoring.CompareMobileStatusWithServer: server session is not active, so exit");
      return;
    }

    if ((this.monitorSession.ActiveMonitor === true) && (this._isMonitorTimerOn))
    {
      // app is already showing that it is an active session
      console.log("Monitoring.CompareMobileStatusWithServer: server session is active, but so is app, so exit");
      return;
    }

    console.log("Monitoring.CompareMobileStatusWithServer: server session is active, but mobile is not, so consider startup mobile session monitoring");
    this.CallGetStatusForMobileMonitor(); // call this to verify status in case we need to re-start monitoring on app
  }
  
  CallGetStatusForMobileMonitor()
  {
    if (this.consoleLog) console.log("Monitoring.CallGetStatusForMobileMonitor");
    if ((this._isApiCallPending === true) || (this._isMonitorTimerOn === true))
    {
      if (this.consoleLog) console.log("Monitoring.CallGetStatusForMobileMonitor - already in progress " + this.monitorSession.MobileMonitorUpdatesCount);
      return;
    }

    this._communicationStatus = "Determining latest status";

    this.apiProvider.GetStatusForMobileMonitor()
    .then(data => { 
      if (this.consoleLog) console.log("MonitorStatus response ", data);
      this._communicationStatus = "Previous status received";
      this.SetApiResponse(data, "GetStatusForMobileMonitor");
      this.HandleSuccessGetStatusForMobileMonitor(data);
      this.HandleSystemAction(data);
      this.SaveCurrentMonitorStatus();
     }
    , errorMessage => {
      console.warn("error " + errorMessage);
      this.HandleErrorFromGetStatusForMobileMonitor();
      // this.RestoreLastKnownMonitorStatus();
    });
  }

  SystemForceEndMobileMonitorStatus()
  {
    if (this.consoleLog) console.log("Monitoring.DummyCallSendMobileMonitorStatus");
    this.SetGeolocationWatchDependency(false);  // this will switch off the dependency based on session code

    this._isApiCallPending = false; 
    this._isApiCallError = false;
    this._isApiCallOk = false;
    
    this.monitorSession.MobileMonitorUpdatesCount = 0;  // reset
    this._communicationStatus = "System force ended session";

    this.SaveCurrentMonitorStatus();
  }

  CallSendMobileMonitorStatus(isInProgress)
  {
    if (this.consoleLog) console.log("Monitoring.CallSendMobileMonitorStatus: inprogress:" + isInProgress);
    if (isInProgress)
    {
      this.CallSendMobileMonitorStatus_INPROG();
    }
    else
    {
      this.CallSendMobileMonitorStatus_END();
    }
  }


  CallSendMobileMonitorStatus_INPROG()
  {
    if (this.consoleLog) console.log("Monitoring.CallSendMobileMonitorStatus_INPROG");

    let MobileMonitorId:number = Number(this.monitorSession.MobileMonitorId);
    this.globalProvider.LatestMonitor.SetLatestMonitor( MobileMonitorId
                                                      , this.monitorSession.EventId
                                                      , this.monitorSession.MobileMonitorTypeCode
                                                      , true);

    this.SetGeolocationWatchDependency(false);

    if (this._isApiCallPending === true)
    {
      if (this.consoleLog) console.log("Monitoring.CallSendMobileMonitorStatus_INPROG - already in progress " + this.monitorSession.MobileMonitorUpdatesCount);
      return;
    }
    this._isApiCallPending = true; 
    this._isApiCallError = false;
    this._isApiCallOk = false;
    
    this.monitorSession.MobileMonitorUpdatesCount += 1;  // increment
    this._communicationStatus = "Communicating latest status";
    this.NotifyCountdownStatus();

    this.apiProvider.SendMobileMonitorStatus( this.monitorSession.MobileMonitorId
                                            , this.monitorSession.MobileMonitorTypeCode
                                            , this.monitorSession.MobileMonitorSessionCode
                                            , this.monitorSession.MobileMonitorUpdatesCount
                                            , this.monitorSession.MobileMonitorChatInTransitText // only send message text when chat button pushed
                                            , this.monitorSession.EventSiteId
                                            )
    .then(data => { 
      if (this.consoleLog) console.log("Monitoring.CallSendMobileMonitorStatus_INPROG: MonitorStatus response ", data);
      this._communicationStatus = "Status update received";
      this._isApiCallPending = false;
      this._isApiCallOk = true;
      this._isApiCallError = false;
      this.SetApiResponse(data, "SendMobileMonitorStatus");
      this.HandleSuccessSendMobileMonitorStatus(data); 
      this.MoveStatusToInProgress();
      this.HandleSystemAction(data);
      this.SaveCurrentMonitorStatus();
     }
    , errorMessage => {
      console.warn("error " + errorMessage);
      this._isApiCallPending = false;
      this._isApiCallOk = false;
      this._isApiCallError = true;
      this._communicationStatus = "Error - trying again";
      this.SaveCurrentMonitorStatus();
    });
  }

  CallSendMobileMonitorStatus_END()
  {
    if (this.consoleLog) console.log("Monitoring.CallSendMobileMonitorStatus_END");

    let MobileMonitorId:number = Number(this.monitorSession.MobileMonitorId);
    this.globalProvider.LatestMonitor.SetLatestMonitor( MobileMonitorId
                                                      , this.monitorSession.EventId
                                                      , this.monitorSession.MobileMonitorTypeCode
                                                      , false);
    this.SetGeolocationWatchDependency(false);

    this._isApiCallPending = true; 
    this._isApiCallError = false;
    this._isApiCallOk = false;
    
    this.monitorSession.MobileMonitorUpdatesCount += 1;  // increment
    this._communicationStatus = "Communicating latest status";
    this.NotifyCountdownStatus();

    this.apiProvider.SendMobileMonitorStatus( this.monitorSession.MobileMonitorId
                                            , this.monitorSession.MobileMonitorTypeCode
                                            , Constants.MONITOR_END // this.monitorSession.MobileMonitorSessionCode
                                            , this.monitorSession.MobileMonitorUpdatesCount
                                            , this.monitorSession.MobileMonitorChatInTransitText // only send message text when chat button pushed
                                            , this.monitorSession.EventSiteId
                                            )
    .then(data => { 
      if (this.consoleLog) console.log("Monitoring.CallSendMobileMonitorStatus_END - MonitorStatus response ", data);
      this._communicationStatus = "Status update received";
      this._isApiCallPending = false;
      this._isApiCallOk = true;
      this._isApiCallError = false;
      this.SetApiResponse(data, "SendMobileMonitorStatus");
      this.HandleSuccessSendMobileMonitorStatus(data); 
      
      // notify parent that the session is complete -- assume the ApiResponse publish will do this
      // this.events.publish('isMonitorEnded', { isMonitorEnded: true });

      this.HandleSystemAction(data);
      this.SaveCurrentMonitorStatus();
     }
    , errorMessage => {
      console.warn("Monitoring.CallSendMobileMonitorStatus_END - error " + errorMessage);
      this._isApiCallPending = false;
      this._isApiCallOk = false;
      this._isApiCallError = true;
      this._communicationStatus = "Error - trying again";
      this.SaveCurrentMonitorStatus();
    });
  }
  // =========================== Handle API Response ===========================

  HandleSuccessGetStatusForMobileMonitor(apiResponse)
  {
    if (this.consoleLog) console.log("Monitoring.HandleSuccessGetStatusForMobileMonitor");
    this.monitorSession.ActiveMonitor = this.commonProvider.GetBoolean(apiResponse.MobileDashboard.DashboardMonitorActiveInd, false);
    //this.monitorSession.ActiveMonitor = this._isMonitoring;
    
    if (this.consoleLog) console.log("Monitoring - DashboardMonitorActiveInd:" + this.monitorSession.ActiveMonitor);
    if (this.monitorSession.ActiveMonitor === false)
    {
      return;
    }

    console.warn("Monitoring.HandleSuccessGetStatusForMobileMonitor - DashboardMonitorActiveInd:" + this.monitorSession.ActiveMonitor);

    // load the fields from the dashboard that would typically be set by user interaction
    this.monitorSession.MobileMonitorTypeCode = apiResponse.MobileDashboard.DashboardMonitorTypeCode;
    this.monitorSession.MobileMonitorSessionCode = Constants.MONITOR_SESSION_INPROGRESS;
    //this.monitorSession.MobileMonitorUpdatesCount = this.commonProvider.GetNumber(apiResponse.MobileDashboard.DashboardMonitorUpdatesCount, 0);
    // = apiResponse.MobileDashboard.DashboardMonitorStatusText


    // load up the Session Object from the dashboard response
    this.monitorSession.EventGuid = apiResponse.Event.EventGuid;
    this.monitorSession.EventId = apiResponse.Event.EventId;

    // apiResponse.MobileDashboard.DashboardMonitor.....
    this.monitorSession.MobileMonitorId = apiResponse.MobileDashboard.DashboardMonitorId;
    
    //this.monitorSession.MobileMonitorStatusText = apiResponse.MobileDashboard.DashboardMonitorStatusText
    //this.monitorSession.MobileMonitorLatestMobileDatetime = apiResponse.MobileDashboard.DashboardMonitorLatestMobileDatetime
    this.monitorSession.MobileMonitorLatestMobileDatetime = apiResponse.ApiReturn.EndDatetimeUtc;  // TEMPORARY USAGE OF ApiReturn FOR THIS DATA
    if (this.consoleLog) console.log("Get latest status - MobileMonitorLatestMobileDatetime:" + this.monitorSession.MobileMonitorLatestMobileDatetime, apiResponse.ApiReturn);  // TEMPORARY USAGE OF ApiReturn FOR THIS DATA

    this.monitorSession.MobileMonitorSystemMessageUser = apiResponse.MobileMonitor.MobileMonitorSystemMessageUser;
    this.monitorSession.MobileMonitorSystemMessageText = apiResponse.MobileMonitor.MobileMonitorSystemMessageText;
    this.monitorSession.MobileMonitorMobileMessageUser = apiResponse.MobileMonitor.MobileMonitorMobileMessageUser;  
    this.monitorSession.MobileMonitorMobileMessageText = apiResponse.MobileMonitor.MobileMonitorMobileMessageText;  

    if (apiResponse.MobileMonitor.MonitorChatMessages)
    {
      this.SetChatMessages(apiResponse.MobileMonitor.MonitorChatMessages, apiResponse.MobileMonitor);
    }

    // apiResponse.MobileLocation.
    //this.monitorSession.LocationFormattedAddress = apiResponse.MobileLocation.LocationFormattedAddress;
    //this.monitorSession.LocationAdminDistrict = apiResponse.MobileLocation.LocationAdminDistrict;   
    //this.monitorSession.LocationFormattedAddress = apiResponse.MobileLocation.LocationFormattedAddress;  
    //this.monitorSession.LocationAdminDistrict2 = apiResponse.MobileLocation.LocationAdminDistrict2;  
    //this.monitorSession.LocationAddressConfidenceLevel = apiResponse.MobileLocation.LocationAddressConfidenceLevel;   
    //this.monitorSession.GpsPositionChangedCounter = apiResponse.MobileLocation.GpsPositionChangedCounter; 

    // this is not being returned by the API, so for now use the local stroage for it.
    //$scope.MobileMonitorSystemMessageUser = $localStorage.MobileMonitorSystemMessageUser;// ||  "";
    //$scope.MobileMonitorSystemMessageText = $localStorage.MobileMonitorSystemMessageText;// ||  "";
    //$scope.MobileMonitorMobileMessageUser = $localStorage.MobileMonitorMobileMessageUser;// ||  "";
    //$scope.MobileMonitorMobileMessageText = $localStorage.MobileMonitorMobileMessageText;// ||  "";
    
    // if (this.consoleLog) 

    let MobileMonitorId = Number(this.monitorSession.MobileMonitorId);
    if (this.globalProvider.LatestMonitor.IsThisLatestMonitorAndActive(MobileMonitorId, this.monitorSession.ActiveMonitor) )
    {
      console.warn("Monitoring.HandleSuccessGetStatusForMobileMonitor - Reviving a Session that got lost on the mobile app", this.monitorSession);
      this.ReviveInProgressMonitorSession();
    }
    else
    {
      console.log("MOnitoring.HandleSuccessGetStatusForMobileMonitor - this is not the latest monitor OR it already ended - no need to revive");
    }

  }

  SetChatMessages(MonitorChatMessages:any, MobileMonitor:any)
  {
    //if (this.consoleLog) 
    console.log("SetChatMessages", MonitorChatMessages);
    
    this.SetRecentChatMessageOnly(MobileMonitor);
    this.SetChatMessagesArray(MonitorChatMessages);
    this.SetLatestChatMessages();  // MUST follow   SetChatMessagesArray
  }

  SetRecentChatMessageOnly(MobileMonitor:any)
  {
    // set the recent chat message - legacy way of handling messages --maybe remove later??
    this.monitorSession.MobileMonitorSystemMessageUser = MobileMonitor.MobileMonitorSystemMessageUser;
    this.monitorSession.MobileMonitorSystemMessageText = MobileMonitor.MobileMonitorSystemMessageText;
    this.monitorSession.MobileMonitorMobileMessageUser = MobileMonitor.MobileMonitorMobileMessageUser;  
    this.monitorSession.MobileMonitorMobileMessageText = MobileMonitor.MobileMonitorMobileMessageText; 

    if (this.monitorSession.MobileMonitorMobileMessageText)
    {
      // override the mobile user name with a "You" for display purposes
      this.monitorSession.MobileMonitorMobileMessageUser = "You";
    }
  }

  SetChatMessagesArray(MonitorChatMessages:any):void
  {
    if (this.consoleLog) console.log("SetChatMessagesArray");

    // ----------------------------
    // no records found
    // ----------------------------
    if (MonitorChatMessages.length === 0)
    {
      //if (this.consoleLog) 
      console.log("SetChatMessagesArray - NO CHAT MESSAGES");
      this.monitorSession.MonitorChatCount = 0;
      this.monitorSession.ChatMessageArray = null;
      return;
    }

    // ----------------------------
    // no new chat records 
    // ----------------------------
    if (   (MonitorChatMessages.length <= this.monitorSession.MonitorChatCount)
        && (!this.monitorSession.MobileMonitorChatInTransitText)
       )
    {
      //if (this.consoleLog) 
      console.log("SetChatMessagesArray - NO ADDITIONAL MESSAGES");
      return;
    }
  
    // ----------------------------
    // records found
    // ----------------------------
    //if (this.consoleLog) 
      console.log("SetChatMessagesArray - NEW MESSAGES FOUND");
    this.monitorSession.MonitorChatCount = MonitorChatMessages.length;
    this.monitorSession.ChatMessageArray = [];  // initialize array

// tslint:disable-next-line: forin
    for (let i in MonitorChatMessages)
    { 
      let chatMessage:ChatMessage = new ChatMessage();

      chatMessage.ChatMessageText = MonitorChatMessages[i].ChatMessageText;                // "I am lost"
      chatMessage.ChatReceivedFlag = MonitorChatMessages[i].ChatReceivedFlag;              // false
      chatMessage.MessageChatDatetime = MonitorChatMessages[i].MessageChatDatetime;        // "3/19/2019 1:08:52 AM"
      chatMessage.MessageChatDatetimeUtc = MonitorChatMessages[i].MessageChatDatetimeUtc;  // "3/19/2019 1:08:52 AM"
      chatMessage.MobileMonitorActionId = MonitorChatMessages[i].MobileMonitorActionId;    // 12963
      chatMessage.MobileMonitorChatTypeCode = MonitorChatMessages[i].MobileMonitorChatTypeCode;   // "MOBILE"  | "SYSTEM"
      chatMessage.MobileMonitorChatTypeId = MonitorChatMessages[i].MobileMonitorChatTypeId; // 3
      chatMessage.SystemUserDisplayName = MonitorChatMessages[i].SystemUserDisplayName;     // null
      chatMessage.SystemUserId = MonitorChatMessages[i].SystemUserId;                       // 0
      chatMessage.SystemUserMessageFlag = MonitorChatMessages[i].SystemUserMessageFlag;     // false  (System or Mobile message)

      this.monitorSession.ChatMessageArray.push(chatMessage);
    }

    //if (this.consoleLog) 
    console.log("SetChatMessagesArray - complete", this.monitorSession.ChatMessageArray);
  }

  SetLatestChatMessages()
  {
    if (this.consoleLog) console.log("SetLatestChatMessages");
    
    // ----------------------------
    // no records found
    // ----------------------------
    if ((!this.monitorSession) || (!this.monitorSession.ChatMessageArray) || (this.monitorSession.ChatMessageArray.length === 0))
    {
      //if (this.consoleLog) 
      console.log("SetLatestChatMessages - NO CHAT MESSAGES");
      this.monitorSession.LatestChatCount = 0;
      if (this.monitorSession.Latest1ChatMessage.MobileMonitorActionId !== 0)
      {
        this.monitorSession.Latest1ChatMessage = new ChatMessage();
      }
      if (this.monitorSession.Latest2ChatMessage.MobileMonitorActionId !== 0)
      {
        this.monitorSession.Latest2ChatMessage = new ChatMessage();
      }
      return;
    }

    this.monitorSession.LatestChatCount = 0;
    let latestSystemChatMessage:ChatMessage = new ChatMessage();    
    let latestMobileChatMessage:ChatMessage = new ChatMessage();   

    this.monitorSession.ChatMessageArray.forEach(chatMessage => 
    {
      if (chatMessage.SystemUserMessageFlag)
      { 
        latestSystemChatMessage = chatMessage; 
      }
      else
      { latestMobileChatMessage = chatMessage; 
      }
    });

    // set the correct order for the last message from each user type
    if (latestSystemChatMessage.MobileMonitorActionId > latestMobileChatMessage.MobileMonitorActionId)
    {
      this.monitorSession.Latest2ChatMessage = latestSystemChatMessage;
      this.monitorSession.Latest1ChatMessage = latestMobileChatMessage;
    }
    else
    {
      this.monitorSession.Latest1ChatMessage = latestSystemChatMessage;
      this.monitorSession.Latest2ChatMessage = latestMobileChatMessage;
    }

    // indicate the number of latest messages available (0 or 1 or 2)
    if (latestSystemChatMessage.MobileMonitorActionId > 0)
    {
      this.monitorSession.LatestChatCount++;
    }
    if (latestMobileChatMessage.MobileMonitorActionId > 0)
    {
      this.monitorSession.LatestChatCount++;
    }
  }

  HandleErrorFromGetStatusForMobileMonitor()
  {
    if (this.consoleLog) console.log("HandleErrorFromGetStatusForMobileMonitor");
    return;

    // pick up any monitor status that may have started (this will get reset by first status call)

    /*
    $scope.MobileMonitorActiveInd  = $localStorage.MobileMonitorActiveInd ||  false;
    
    if (this.consoleLog) console.log("HandleErrorFromGetStatusForMobileMonitor - DashboardMonitorActiveInd:" + $scope.MobileMonitorActiveInd);
    if ($scope.MobileMonitorActiveInd === "TRUE")
    { 
      $scope.HideMessageChatSend = false;
      var baseDecimal = 10;
      $scope.MobileMonitorUpdatesCount = parseInt($scope.MobileMonitorUpdatesCount, baseDecimal);
      $scope.MobileMonitorId = $localStorage.MobileMonitorId ||  "";
      $scope.MobileMonitorTypeCode = $localStorage.MobileMonitorTypeCode ||  "";
      $scope.MobileMonitorStatusText = $localStorage.MobileMonitorStatusText ||  "";
      $scope.MobileMonitorLatestMobileDatetime = $localStorage.MobileMonitorLatestMobileDatetime ||  "";
      
      $scope.MobileMonitorSystemMessageUser = $localStorage.MobileMonitorSystemMessageUser;// ||  "";
      $scope.MobileMonitorSystemMessageText = $localStorage.MobileMonitorSystemMessageText;// ||  "";
      $scope.MobileMonitorMobileMessageUser = $localStorage.MobileMonitorMobileMessageUser;// ||  "";
      $scope.MobileMonitorMobileMessageText = $localStorage.MobileMonitorMobileMessageText;// ||  "";
      //$scope.Model.MobileMonitorMobilePendingText = $localStorage.MobileMonitorMobilePendingText;// ||  "";
      HandleChatMessageDisplay(); 

      SetMobileMonitorActiveInd(true);
      $scope.MonitorButton = $scope.MobileMonitorTypeCode;
      ResumeMonitorSession();
    }
    else
    {
      SetMobileMonitorActiveInd(false);
      $scope.MonitorButton = Constants.END;
    }
    */
  }

  HandleSuccessSendMobileMonitorStatus(apiResponse)
  {
    if (this.consoleLog) console.log("HandleSuccessSendMobileMonitorStatus:" + apiResponse.MobileMonitor.MobileMonitorId, apiResponse);
    this.monitorSession.EventGuid = apiResponse.Event.EventGuid;
    this.monitorSession.EventId = apiResponse.Event.EventId;

    // apiResponse.MobileDashboard.DashboardMonitor.....
    this.monitorSession.MobileMonitorId = apiResponse.MobileMonitor.MobileMonitorId;
    this.monitorSession.MobileMonitorId = apiResponse.MobileMonitor.MobileMonitorId;
    
    //this.monitorSession.MobileMonitorStatusText = apiResponse.MobileDashboard.DashboardMonitorStatusText
    //this.monitorSession.MobileMonitorLatestMobileDatetime = apiResponse.MobileDashboard.DashboardMonitorLatestMobileDatetime
    this.monitorSession.MobileMonitorLatestMobileDatetime = apiResponse.ApiReturn.EndDatetimeUtc;  // TEMPORARY USAGE OF ApiReturn FOR THIS DATA
    if (this.consoleLog) console.log("In progress - MobileMonitorLatestMobileDatetime:" + this.monitorSession.MobileMonitorLatestMobileDatetime, apiResponse.ApiReturn);  // TEMPORARY USAGE OF ApiReturn FOR THIS DATA

    if (apiResponse.MobileMonitor.MonitorChatMessages)
    {
      this.SetChatMessages(apiResponse.MobileMonitor.MonitorChatMessages, apiResponse.MobileMonitor);
    }
    
    // reset the pending message if it was received successfully (otherwise hope it gets picked up next call)
    // ToDo: this feels like a hack, so return to this later (maybe when we implement a real chat)
    if (this.monitorSession.MobileMonitorChatInTransitText)
    {
      if (this.monitorSession.MobileMonitorChatInTransitText === this.monitorSession.MobileMonitorMobileMessageText)
      {
        console.log("MobileMonitorChatInTransitText - SENT OK - " + this.monitorSession.MobileMonitorChatInTransitText, this.monitorSession);
        this.monitorSession.MobileMonitorChatInTransitText = "";
      }
      else
      {
        console.log("MobileMonitorChatInTransitText - NOT SENT - " + this.monitorSession.MobileMonitorChatInTransitText, this.monitorSession);       
      }
    }
    else 
    {
      console.log("MobileMonitorChatInTransitText - None pending", this.monitorSession);
    }

    
    // apiResponse.MobileLocation.

    // if server did not convert coords to address, then use previous one (if it exists)
    this.monitorSession.LocationStaleAddressFlag = false;      // assume address is present
    if (!apiResponse.MobileLocation.LocationFormattedAddress)  // check if there is an updated address
    {
      if (this.monitorSession.LocationFormattedAddress)        // check if we had an address before
      {
        this.monitorSession.LocationStaleAddressFlag = true;
      }
    }
    else
    {
      // use the updated address received from the server
      this.monitorSession.LocationAddressConfidenceLevel = apiResponse.MobileLocation.LocationAddressConfidenceLevel;  
      this.monitorSession.LocationFormattedAddress = apiResponse.MobileLocation.LocationFormattedAddress;
      this.monitorSession.LocationAdminDistrict = apiResponse.MobileLocation.LocationAdminDistrict;   
      this.monitorSession.LocationAdminDistrict2 = apiResponse.MobileLocation.LocationAdminDistrict2;   

      if (this.monitorSession.LocationAdminDistrict2)
      {
        this.monitorSession.LocationAreaVicinity = this.monitorSession.LocationAdminDistrict2;
      }
      else if (this.monitorSession.LocationAdminDistrict)
      {
        this.monitorSession.LocationAreaVicinity = this.monitorSession.LocationAdminDistrict;
      }
    }
    
    this.monitorSession.GpsPositionChangedCounter = apiResponse.MobileLocation.GpsPositionChangedCounter; 
    this.monitorSession.GeoPosition = this.apiProvider.GetLastUsedGeoPositionMonitor();
  }

  HandleSystemAction(apiResponse)
  {    
    if (this.consoleLog) console.log("ActionsMonitor.HandleSystemAction");

    if (!apiResponse.MobileMonitor.MobileMonitorSystemActionTypeCode)
    {
      return;
    }

    if (apiResponse.MobileMonitor.MobileMonitorSystemActionTypeCode === Constants.MONITOR_FORCE_END_SESSION)
    {
      console.log("Monitoring.HandleSystemAction: FORCE END SESSION");
      this.ForceEndMonitorSession();
    }
    else
    {
    // there may be other system actions in the future...
      console.log("Monitoring.HandleSystemAction: UNKNOWN ACTION - " + apiResponse.MobileMonitor.MobileMonitorSystemActionTypeCode);
    }
  }

    // ToDo:
  SaveCurrentMonitorStatus()
  {
    if (this.consoleLog) console.log("ActionsMonitor.SaveCurrentMonitorStatus");

    /*
    $localStorage.MobileMonitorId = $scope.MobileMonitorId;
    $localStorage.MobileMonitorTypeCode = $scope.MobileMonitorTypeCode;
    $localStorage.MobileMonitorSessionCode = $scope.MobileMonitorSessionCode;
    $localStorage.MobileMonitorUpdatesCount = $scope.MobileMonitorUpdatesCount;
    $localStorage.MobileMonitorActiveInd = $scope.MobileMonitorActiveInd;
    $localStorage.MobileMonitorSystemMessageUser = $scope.MobileMonitorSystemMessageUser;
    $localStorage.MobileMonitorSystemMessageText = $scope.MobileMonitorSystemMessageText;
    $localStorage.MobileMonitorMobileMessageUser = $scope.MobileMonitorMobileMessageUser;
    $localStorage.MobileMonitorMobileMessageText = $scope.MobileMonitorMobileMessageText;
    //$localStorage.MobileMonitorMobilePendingText = $scope.Model.MobileMonitorMobilePendingText;
    */
  }

  RestoreLastKnownMonitorStatus()
  {
    if (this.consoleLog) console.log("ActionsMonitor.RestoreLastKnownMonitorStatus");

    /*
    $scope.MobileMonitorId = $localStorage.MobileMonitorId ||  "";
    $scope.MobileMonitorTypeCode = $localStorage.MobileMonitorTypeCode ||  "";
    $scope.MobileMonitorSessionCode = $localStorage.MobileMonitorSessionCode ||  "END";
    $scope.MobileMonitorUpdatesCount = $localStorage.MobileMonitorUpdatesCount ||  0;
    $scope.MobileMonitorActiveInd = $localStorage.MobileMonitorActiveInd ||  false;
    $scope.MobileMonitorSystemMessageUser = $localStorage.MobileMonitorSystemMessageUser;// ||  "";
    $scope.MobileMonitorSystemMessageText = $localStorage.MobileMonitorSystemMessageText;// ||  "";
    $scope.MobileMonitorMobileMessageUser = $localStorage.MobileMonitorMobileMessageUser;// ||  "";
    $scope.MobileMonitorMobileMessageText = $localStorage.MobileMonitorMobileMessageText;// ||  "";
    //$scope.Model.MobileMonitorMobilePendingText = $localStorage.MobileMonitorMobilePendingText;// ||  "";
    */
  }


  // ----------------------------------------------------
  // -----------   COUNTDOWN TIMER SERVICE    -----------
  // ----------------------------------------------------

  // To avoid any recursive calls...
  // - only call the timer from the start/stop/resume logic
  // - don't ever call the timer from the API call response

  StartTimer() 
  {
    if (this.consoleLog) console.log("Monitoring.StartTimer - existing timerInstance:" + this._timerInstance);
    // Don't start a new countdown timer if one is already in progress
    //if ( this._timerInstance != null) { return; }
    this.StopTimer(); // make sure we don't already have a timer running
    //if ( this._isMonitorTimerOn ) return;

    // initialize the countdown
    this._countdownCurrent = this._countdownTotal;

    // indicate that the timer is running
    if (this.consoleLog) console.log("Monitoring.Timer STARTING");
    this.NotifyCountdownStatus();

    // https://github.com/TypeStrong/atom-typescript/issues/1053
    //this._timerInstance = setInterval(function()   // issue with Node.JS ambient/namespace
    this._timerInstance = window.setInterval( function()   // use "window" to get around typescript issue
    {
      if (this._isMonitorTimerOn === false) { if (this.consoleLog) console.log("Monitoring.StartTimer:" + this._timerInstance + " STARTED"); }
      this._isMonitorTimerOn = true;
      this.NotifyCountdownStatus();

      if (this._countdownCurrent > 0) 
      {
        // we are still counting down, so display the latest countdown decremented value
        //if (this.consoleLog) console.log("Monitoring.Timer:" + this._timerInstance + " Counter:" + this._countdownCurrent + " (B) Display");
        this._countdownCurrent = this._countdownCurrent - 1;
      } 
      else // if (this._countdownCurrent === 0)
      {
        // we have ended the countdown, call the API with the latest update
        //this.StopTimer();
        if (this.consoleLog) console.log("Monitoring.Timer _timerInstance:" + this._timerInstance + " Counter:" + this._countdownCurrent + " (C) CallApi");
        this.CallSendMobileMonitorStatus(true);  
        this._countdownCurrent = this._countdownTotal;  // reset the countdown
      }
    }.bind(this), 1000);  // 1000 milliseconds = 1 second
  }

  PauseTimer() 
  {
    if (this.consoleLog) console.log("Monitoring.Timer:" + this._timerInstance + " PAUSED");
    if ( this._timerInstance != null) 
    {
      // kill the timer if there is one
      clearInterval(this._timerInstance);
      this._isMonitorTimerOn = false;
    }
    // do NOT set these fields as we are just pausing the timer to send a chat message
    //this._isMonitorTimerOn = false;
    //this.MobileMonitorActiveInd = false;
    //this.PageHeaderText = "Paused";
  }

  StopTimer() 
  {
    if ( this._timerInstance != null) 
    {
      // kill the timer if there is one
      if (this.consoleLog) console.log("Monitoring.Timer:" + this._timerInstance + " STOPPED");
      clearInterval(this._timerInstance);
    }
    this._isMonitorTimerOn = false;
    this.NotifyCountdownStatus();
    //this.MobileMonitorActiveInd = false;
    //this.PageHeaderText = "Stopped";
  }

  NotifyCountdownStatus()
  {
    //if (this.consoleLog) console.log("Monitoring.NotifyCountdownStatus: " + this._isMonitorTimerOn + " " + this._countdownCurrent);
    if (this.monitorTimerObserver)
    {
      this.monitorTimerObserver.next(this._isMonitorTimerOn, this._countdownCurrent);
    }

    if (this.consoleLog) console.log("monitoring.NotifyCountdownStatus - Timer:" + this._isMonitorTimerOn + " Countdown:" + this._countdownCurrent);
    this.events.publish('monitorCountdown', { CountdownCurrent: this._countdownCurrent });

    /*
    if (this._countdownCurrent < this.TimeMessageChange)
    {
      this.PageHeaderText = $translate.instant("Countdown to next update") + " ... " + $scope._countdownCurrentDisplay;
    } 
    */
  }

  GetMonitorCountdownCurrent():number
  {
    return this._countdownCurrent;
  }

  GetMobileMonitorUpdatesCount():number
  {
    return this.monitorSession.MobileMonitorUpdatesCount;
  }
  
  // ============================================

  MoveStatusToInProgress()
  {
    //if (!this._isMonitoring)
    if (!this.monitorSession.ActiveMonitor)
    {
      if (this.monitorSession.MobileMonitorSessionCode === Constants.MONITOR_SESSION_START)
      {
        this.monitorSession.MobileMonitorSessionCode = Constants.MONITOR_SESSION_INPROGRESS;
      }
    }
  }

}
